import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationCH from './locales/ch/translation.json';
import translationJA from './locales/ja/translation.json';
import translationKO from './locales/ko/translation.json';
import translationFR from './locales/fr/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  ch: {
    translation: translationCH,
  },
  ja: {
    translation: translationJA,
  },
  ko: {
    translation: translationKO,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

export const LANGUAGES = {
  en: {
    name: 'English',
    flag: '🇺🇸'
  },
  fr: {
    name: 'Français',
    flag: '🇫🇷'
  },
  ch: {
    name: '中文',
    flag: '🇨🇳'
  },
  ja: {
    name: '日本語',
    flag: '🇯🇵'
  },
  ko: {
    name: '한국어',
    flag: '🇰🇷'
  },
  ar: {
    name: 'العربية',
    flag: '🇸🇦'
  }
}; 